import { createI18n } from 'vue-i18n'
import Cookies from 'js-cookie'

import enLocale from './en'
import plLocale from './pl'
import ruLocale from './ru'
import { polishPluralization } from './rules/polishPluralization'

export const messages = {
  en: enLocale,
  pl: plLocale,
  ru: ruLocale
}

const i18n = createI18n({
  locale: Cookies.get('language') || 'en',
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages,
  legacy: false,
  pluralRules: {
    pl: polishPluralization
  }
})

export default i18n
